import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/i18n'
import '@/styles/index.css'
import { isMockMode } from '@/config/runtime'
// Side effect: wires the single-flight refresh into the transports.
import '@/auth/actions'
import { App } from './App'

async function boot() {
  // import.meta.env.VITE_ENABLE_MOCK is replaced at build time: in a
  // production bundle this whole branch — and the dynamic import of the mock
  // transport — is dropped.
  if (import.meta.env.VITE_ENABLE_MOCK === '1' && isMockMode()) {
    const { installMockTransport } = await import('@/mock/mockTransport')
    installMockTransport()
  }
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}

void boot()
